import { useAffiliateList } from '@/features/users/affiliate/hooks/useAffiliateList';
import { AffiliateTable } from '@/features/users/affiliate/table';
import { SearchSchemaInput, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['rewardPoints', 'mobileNumber', 'emailAddress', 'affiliateInfo', 'status', 'createdDate', 'updatedDate']),
  desc: z.boolean(),
});

const AffiliateSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z
    .string()

    .optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
    .optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/users/affiliates/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => AffiliateSearchSchema.parse(search),
});
function RouteComponent() {
  const { affiliates, isLoading, pagination } = useAffiliateList();
  return <AffiliateTable data={affiliates} isLoading={isLoading} pagination={pagination} />;
}
